export default "__VITE_PUBLIC_ASSET__8a3c986f__"